<template>
  <b-sidebar
    id="sidebar-right"
    z-index="51001"
    title="Edit todo"
    right
    shadow
    :visible="active"
    backdrop
    no-header
    sidebar-class="sidebar-lg"
    header-class="header-dark"
    bg-variant="white"
    width="420px"
    @change="(val) => $emit('update:active', val)"
    @hidden="clearForm"
  >
    <!-- @hidden="clearForm" -->
    <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

    <template #default="{ hide }" v-if="todo">
      <!-- Header -->
      <div
        class="
          header-dark
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-4
          py-3
        "
      >
        <b-button
          size="sm"
          :disabled="true"
          :variant="
            (todo.completed ? 'success' : 'outline-danger') + ' rounded-lg'
          "
        >
          {{ todo.completed ? "Done" : "Not done" }}
        </b-button>

        <!--   <h5 v-else class="mb-0">Add Task</h5> -->
        <div>
<!--           <feather-icon
            class="mr-2 cursor-pointer"
            icon="FlagIcon"
            :style="{
              color: todo.flagged
                ? 'rgba(var(--vs-success), 1)'
                : ' rgba(var(--vs-primary), 1)',
            }"
            @click="todo.flagged = !todo.flagged"
            svgClasses="h-5 w-5 stroke-2"
          /> -->
          <feather-icon
            icon="TrashIcon"
            class="cursor-pointer ml-3 mr-2"
            svgClasses="h-5 w-5 stroke-2"
            @click="
              $emit('delete:todo', todo);
              hide();
            "
          />

          <feather-icon
            class="ml-3 cursor-pointer"
            icon="XIcon"
            svgClasses="h-5 w-5 stroke-2"
            @click="hide"
          />
        </div>
      </div>

      <div class="px-4">
        <!-- Form start -->
        <div>
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <p class="mt-4">General</p>
                <label class="form-label">Title</label>
                <vs-input
                  name="title"
                  v-model="todo.title"
                  class="w-full"
                  placeholder="Example: empty trash"
                />

                <label class="form-label mt-2">Note</label>
                <vs-input
                  name="title"
                  v-model="todo.note"
                  class="w-full"
                  placeholder="Note"
                />
                <label class="form-label mt-2">Flag as important</label>

                <div class="vx-col">
                  <vx-tooltip
                    :text="
                      todo.flagged
                        ? 'Click to remove flag'
                        : 'Click to mark this todo with a flag'
                    "
                    position="bottom"
                  >
                    <feather-icon
                      v-if="!todo.flagged"
                      icon="FlagIcon"
                      svgClasses="w-6 h-6 hover:text-primary cursor-pointer"
                      @click.stop="todo.flagged = true"
                    />
                    <feather-icon
                      v-if="todo.flagged"
                      icon="FlagIcon"
                      svgClasses="w-6 h-6 text-warning cursor-pointer"
                      @click.stop="todo.flagged = false"
                    />
                  </vx-tooltip>
                </div>
                <vs-divider />
                <p class="">Additional info</p>
                <label class="form-label">Place</label>
                <p>
                  {{ todo.address ? todo.address : "No place" }}
                  <a
                    v-if="!showGmap"
                    class="cursor-pointer"
                    @click="showGmap = true"
                    ><small>change</small></a
                  >
                </p>

                <gmap-autocomplete
                  v-if="showGmap"
                  class="addressInput vs-inputx vs-input--input normal"
                  placeholder="Type location or address"
                  @place_changed="updateAddress"
                  :value="todo.address"
                  :select-first-on-enter="true"
                >
                </gmap-autocomplete>

                <label class="form-label mt-1">Due date</label>
                <!-- :model-config="modelConfig"  :min-date="todo.dueDate ? todo.dueDate : new Date()"-->
                <v-date-picker v-model="todo.dueDate" mode="dateTime" is24hr>
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="flex justify-between">
                      <vs-input
                        name="Due date"
                        :value="inputValue"
                        v-on="inputEvents"
                        class="w-full"
                        placeholder="Due date (optional)"
                      />
                      <feather-icon
                        v-if="todo.dueDate"
                        icon="XIcon"
                        class="ml-1 cursor-pointer"
                        svgClasses="h-5 w-5"
                        @click="
                          todo.dueDate = null;
                          todo.notifyMe = false;
                        "
                      />
                    </div>
                  </template>
                </v-date-picker>
                <vx-tooltip
                  text="Enable to receive a notification in the LIFE app when todo is due"
                  position="top"
                >
                  <vs-checkbox
                    class="mt-3"
                    :disabled="!todo.dueDate"
                    v-model="todo.notifyMe"
                    >Notify in LIFE app</vs-checkbox
                  >
                </vx-tooltip>
                <vs-divider />
                <p>Photos</p>
                <MediaControllerImagesBox
                  v-model="todo.imageUrls"
                  type="PersonalTodo"
                />

                <vs-divider />
                <vs-row class="flex flex-wrap items-center mt-4">
                  <vs-button
                    class="mr-5 rounded-lg"
                    color="warning"
                    @click="
                      $emit('update:todo');
                      hide();
                    "
                    >Save</vs-button
                  >
                  <vs-button class="rounded-lg" color="primary" @click="hide"
                    >Cancel</vs-button
                  >
                </vs-row>
                <!-- end  -->
              </div>
            </div>
          </form>
        </div>
        <!-- Form end -->
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from "vuex";
import MediaControllerImagesBox from "./MediaControllerImagesBox.vue";
export default {
  components: { MediaControllerImagesBox },
  data() {
    return {
      //   modelConfig: {
      //     type: "string",
      //     mask: "iso",
      //   },
      selected: null,
      showGmap: false,
    };
  },
  props: {
    todo: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["update:active", "update:todo", "delete:todo"],
  computed: {
    ...mapGetters({}),
  },
  methods: {
    errorUpload(err) {
      console.log(err);
    },
    successUpload(response) {
      console.log("succ", response);
      //this.todo.imageUrls.push(response.data);
    },
    deleteUpload(response) {
      console.log("delete", response);
    },
    updateAddress: function (payload) {
      this.showGmap = false;
      this.todo.address = payload.formatted_address;
      const lat = payload.geometry.location.lat();
      const lng = payload.geometry.location.lng();

      this.todo.latitude = lat;
      this.todo.longitude = lng;
    },
    changeType(type) {
      this.todo.type = type;
    },
    clearForm() {
      console.log("Clear form");
    },
  },
  async mounted() {},
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
